import CustomSearchBar from "components/CustomSearchBar";
import { Col, Row, Button } from "reactstrap";
import { useEffect, useState } from "react";
import Pagination from "@mui/material/Pagination";
import { DataGrid } from "@mui/x-data-grid";
import { toast } from "react-toastify";
import "react-loading-skeleton/dist/skeleton.css";
import { useAssignPolicyDetailsMutation } from "features/CrmDashboardComp/CmrApiSlice";
import {
  useGetAssignPolicyQuery,
  useGetCrmInsuranceLeadsQuery,
} from "features/Insurance/InsuranceApiSlice";
import { Tag } from "antd";
import Swal from "sweetalert2";
import Select from "react-select";

import {
  TextField,
  MenuItem,
  Box,
  Divider,
  CircularProgress,
} from "@mui/material";
import {
  useGetDistrictByStateQuery,
  useGetStatesQuery,
} from "services/locationApiSlice";

const InsurancePolicyIssue = ({ refetch, setPolicyModal }) => {
  const [pagination, setPagination] = useState({
    page: 1,
    pageCount: 0,
    perPage: 50,
  });
  const [searchKeyStatus, setSearchKeyStatus] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [stateId, setStateId] = useState("");
  const [districtId, setDistrictId] = useState("");
  const [stateName, setStateName] = useState("");
  const [districtName, setDistrictName] = useState("");
  const [stateList, setStateList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const {
    data: getStates,
    isLoading: loadingStateOptions,
  } = useGetStatesQuery();
  const {
    data: dataDistrict,
    isLoading: loadingDistrictOptions,
  } = useGetDistrictByStateQuery(stateId);
  const [policyStatus, setPolicyStatus] = useState("Policy Issued");
  const [remarks, setRemarks] = useState("");
  const [policyDetails, setPolicyDetails] = useState({
    policy_id: "",
    policy_url: "",
    file: null,
  });
  const status = "Proposal Form Submitted";

  // const { data, refetch: refetchLeads, isLoading } = useGetAssignPolicyQuery({
  //   pagination,
  //   searchKeyStatus: debouncedSearch ? debouncedSearch : "",
  //   status,
  //    stateId: stateId,
  //   districtId: districtId,
  // });
  const queryParameters = {
    page: pagination.page,
    perPage: pagination.perPage,
    searchKey: searchKeyStatus ? searchKeyStatus : "",
    selectedProduct: "Cattle",
    stateCode: stateId,
    districtCode: districtId,
    blockCode: "",
    // statusName: "Proposal Form Submitted",
        statusName: "",

    statusIncludes: "Proposal Form Submitted",
  };
  const {
    data,
    refetch: refetchLeads,
    isLoading,
  } = useGetCrmInsuranceLeadsQuery(queryParameters);
  const [assignLeads] = useAssignPolicyDetailsMutation();
  const [leadList, setLeadList] = useState([]);
  const [filterIdAgain, setFilterIdAgain] = useState([]);

  const columns = [
    { field: "full_name", headerName: "Name", width: 180 },
    { field: "phone_number", headerName: "Phone Number", width: 160 },
    { field: "lead_source", headerName: "Lead Source", width: 180 },

    {
      field: "current_status",
      headerName: "Application Status",
      width: 220,
      renderCell: (cellValues) => {
        const status = cellValues.row.current_status;

        const statusConfig = {
          "Lead Details Modified": {
            color: "blue",
          },
          Assigned: { color: "gold" },
          "Can Not Process": { color: "error" },
          "Lead Generated": { color: "volcano" },
        };

        const { color, icon } = statusConfig[status] || {
          color: "geekblue",
        };

        return (
          <Tag
            bordered={false}
            color={color}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              padding: "3px 9px",
              fontSize: "13px",
              fontWeight: "500",
              borderRadius: "6px",
            }}
          >
            {icon}
            <span>{status}</span>
          </Tag>
        );
      },
    },
    { field: "state_name", headerName: "State", width: 150 },
  ];
  const CustomPagination = () => {
    return (
      <Pagination
        color="primary"
        count={pagination?.pageCount}
        page={pagination?.page}
        onChange={(event, value) => {
          setPagination({
            page: value,
            pageCount: pagination?.pageCount,
            perPage: pagination.perPage,
          });
        }}
        variant="outlined"
        shape="rounded"
      />
    );
  };
  const filterDataBasedId = (item) => {
    setFilterIdAgain(item);
  };
  useEffect(() => {
    if (data) {
      setLeadList(data?.data?.results || []);
      setPagination({
        page: data?.data?.current_page || 1,
        pageCount: data?.data?.pages || 0,
        perPage: data?.data?.per_page || 50,
      });
    }
  }, [data]);
  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "40px",
      height: "40px",
      padding: "0px",
      fontSize: "12px",
    }),
  };
  useEffect(() => {
    if (getStates != undefined) {
      setStateList(getStates?.data?.results);
    }
  }, [getStates]);
  const handleStateOptions = () => {
    let responseAgentArray = [];
    stateList.map((state) => {
      responseAgentArray.push({
        value: state.state_code,
        label: state.state_name,
        ConditionName: "state",
      });
    });
    return responseAgentArray;
  };
  const handleDistrictOptions = () => {
    let responseAgentArray = [];
    districtList.map((district) => {
      responseAgentArray.push({
        value: district.district_code,
        label: district.district_name,
        ConditionName: "district",
      });
    });
    return responseAgentArray;
  };
  const onLocationChange = (event) => {
    if (event.ConditionName == "state") {
      setDistrictId("");
      setStateId(event.value);
      setStateName(event.label);
    }
    if (event.ConditionName == "district") {
      setDistrictId(event.value);
      setPagination({ page: 1, pageCount: 0, perPage: 50 });
      setDistrictName(event.label);
    }
  };

  useEffect(() => {
    if (dataDistrict != undefined) {
      setDistrictList(dataDistrict?.data?.results);
    }
  }, [dataDistrict]);

  const handleAssign = (e) => {
    e.preventDefault();
    if (policyStatus === "Policy Issued") {
      if (!policyDetails.policy_url && !policyDetails.file) {
        Swal.fire({
          title: "Enter Details",
          text: "Please provide either a Policy URL or upload a document.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Continue",
          cancelButtonText: "Cancel",
          confirmButtonIcon: "fas fa-arrow-right",
        });
        return;
      }
      if (policyDetails.policy_url && policyDetails.file) {
        Swal.fire({
          title: "Enter Details",
          text:
            "You can only provide either a Policy URL or a document, not both.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Continue",
          cancelButtonText: "Cancel",
          confirmButtonIcon: "fas fa-arrow-right",
        });
        return;
      }
    }
    if (filterIdAgain?.length === 0) {
      Swal.fire({
        title: "Select Leads",
        text: "Please select Leads for Policy",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Continue",
        cancelButtonText: "Cancel",
        confirmButtonIcon: "fas fa-arrow-right",
      });
      return;
    }
    let payload = new FormData();
    //     filterIdAgain.forEach((id, index) => {
    //   payload.append(`lead_id_list[${index}]`, id);
    // });
    // payload.append("lead_id_list", JSON.stringify(filterIdAgain));
    //    filterIdAgain.forEach(id => {
    //   payload.append("lead_id_list", id);
    // });
    // payload.append("lead_id_list", filterIdAgain);
    payload.append("lead_id_list", JSON.stringify(filterIdAgain));

    payload.append("current_remarks", remarks);
    payload.append("current_status", policyStatus);
    if (policyStatus === "Policy Issued") {
      payload.append("policy_id", policyDetails.policy_id);
    }
    if (policyStatus === "Policy Issued" && policyDetails.file === null)
      payload.append("policy_url", policyDetails.policy_url);
    if (policyStatus === "Policy Issued" && policyDetails.policy_url === "")
      payload.append("policy_document", policyDetails.file);

    assignLeads(payload)
      .unwrap()
      .then(() => {
        toast.success("Policy Issued Successfully!");
        setRemarks("");
        setPolicyDetails({ policy_id: "", policy_url: "", file: null });
        refetchLeads();
        refetch();
        setPolicyModal(false);
      })
      .catch(() => toast.error("Error while Issuing Policy. Try again later!"));
  };
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchKeyStatus.trim() ? searchKeyStatus : "");
    }, 500);

    return () => clearTimeout(handler);
  }, [searchKeyStatus]);
  const [policyUrlError, setPolicyUrlError] = useState("");

  const validatePolicyUrl = (url) => {
    if (!url) return "Policy URL is required";
    if (!/^https?:\/\/.+/i.test(url)) return "Enter a valid URL";
    if (!url.toLowerCase().endsWith(".pdf")) return "URL must end with .pdf";
    return "";
  };

  return (
    <div className="p-3">
      <Row>
        <Col lg="6">
          <TextField
            select
            size="small"
            label="Select Policy Status"
            value={policyStatus}
            onChange={(e) => setPolicyStatus(e.target.value)}
          >
            <MenuItem value="Policy Issued">Policy Issued</MenuItem>
            <MenuItem value="Policy Rejected">Policy Rejected</MenuItem>
          </TextField>
        </Col>
      </Row>
      {(policyStatus === "Policy Issued" ||
        policyStatus === "Policy Rejected") && (
        <form onSubmit={handleAssign}>
          {policyStatus === "Policy Issued" && (
            <Row className="mt-3">
              <Col lg="3">
                <TextField
                  type="text"
                  fullWidth
                  label="Policy Id"
                  value={policyDetails.policy_id}
                  onChange={(e) =>
                    setPolicyDetails({
                      ...policyDetails,
                      policy_id: e.target.value,
                    })
                  }
                  required
                  size="small"
                />
              </Col>
              <Col lg="4">
                {/* <TextField type="text" fullWidth label="Policy URL" value={policyDetails.policy_url} onChange={(e) => setPolicyDetails({ ...policyDetails, policy_url: e.target.value, file: null })} size="small" disabled={policyDetails.file !== null} /> */}
                <TextField
                  type="text"
                  fullWidth
                  size="small"
                  label="Policy URL"
                  value={policyDetails.policy_url}
                  onChange={(e) => {
                    const value = e.target.value;
                    setPolicyDetails({
                      ...policyDetails,
                      policy_url: value,
                      file: null,
                    });
                    setPolicyUrlError(validatePolicyUrl(value));
                  }}
                  disabled={policyDetails.file !== null}
                  error={!!policyUrlError}
                  helperText={policyUrlError}
                />
              </Col>
              <Col lg="3">
                <input
                  type="file"
                  accept=".pdf"
                  onChange={(e) => {
                    setPolicyDetails({
                      ...policyDetails,
                      file: e.target.files[0],
                      policy_url: "",
                    });
                    setPolicyUrlError("");
                  }}
                  disabled={policyDetails.policy_url !== ""}
                />
              </Col>
            </Row>
          )}
          <Row className="mt-4">
            <Col lg="6">
              <TextField
                type="text"
                fullWidth
                label="Remarks"
                value={remarks}
                onChange={(e) => setRemarks(e.target.value)}
                required
                size="small"
              />
            </Col>
            <Col md="2" className="mx-3">
              <Button
                id="AddLeads"
                className="buttonGreenDefaultColor"
                size="sm"
                type="submit"
              >
                Submit &nbsp;
                <i className="mdi mdi-account-arrow-right custom-btn-fs fs-6"></i>
              </Button>
            </Col>
          </Row>
        </form>
      )}
      <Divider className="mt-3 mb-3" />
      <div className="row mt-2 p-1">
        <Col md="2" className="mt-4">
          <CustomSearchBar sendSearchFunction={setSearchKeyStatus} />
        </Col>
        <Col md="2" className="mb-2 position-relative">
          <Select
            menuPlacement="auto"
            options={handleStateOptions()}
            placeholder={stateId === "" ? "State" : stateName}
            value={stateId === "" ? null : { value: stateId, label: stateName }}
            onChange={onLocationChange}
            styles={customStyles}
            isLoading={loadingStateOptions}
            className="mt-4"
          />
          {stateId && (
            <span
              className="clear-icon"
              onClick={() => {
                setStateId("");
                setStateName("");
              }}
              style={{
                position: "absolute",
                top: "76%",
                right: "60px",
                transform: "translateY(-50%)",
                cursor: "pointer",
                color: "gray",
                fontSize: "12px",
                zIndex: 1000,
              }}
            >
              ✕
            </span>
          )}
        </Col>
        <Col md="2" className="mb-2 position-relative">
          <Select
            menuPlacement="auto"
            options={handleDistrictOptions()}
            placeholder={districtName === "" ? "District" : districtName}
            value={
              districtName === ""
                ? null
                : { value: districtId, label: districtName }
            }
            onChange={onLocationChange}
            styles={customStyles}
            isLoading={loadingDistrictOptions}
            className="mt-4"
          />
          {districtName && (
            <span
              className="clear-icon"
              onClick={() => {
                setDistrictId("");
                setDistrictName("");
              }}
              style={{
                position: "absolute",
                top: "76%",
                right: "60px",
                transform: "translateY(-50%)",
                cursor: "pointer",
                color: "gray",
                fontSize: "12px",
                zIndex: 1000,
              }}
            >
              ✕
            </span>
          )}
        </Col>
      </div>
      <Box sx={{ width: "100%", mt: 2 }}>
        <DataGrid
          rows={leadList}
          columns={columns}
          loading={isLoading}
          autoHeight
          checkboxSelection
          onRowSelectionModelChange={(item) => filterDataBasedId(item)}
          components={{
            Pagination: CustomPagination,
          }}
          slots={{
            pagination: CustomPagination,
            loadingOverlay: () => (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100px",
                }}
              >
                <CircularProgress size={32} />
              </Box>
            ),
          }}
        />{" "}
      </Box>
    </div>
  );
};

export default InsurancePolicyIssue;
